import invariant from 'react-utils/invariant';
import performanceMarkInvariant from '../marks/performanceMarkInvariant';
const performanceMeasurementInvariant = measurement => {
  invariant(typeof measurement === 'object' && typeof measurement.name === 'string' && performanceMarkInvariant(measurement.start) && performanceMarkInvariant(measurement.end), `invalid performance measurement shape ${measurement && measurement.name ? measurement.name : measurement}`);
};
export default performanceMeasurementInvariant;